export class PageableCarteiraFilter {
  constructor(public pageSize, public pageNumber, public nome?: string, public nomeCompleto?: string, public ativa : boolean = null, public auto : boolean = null) {
  }
}
